<template>
  <v-container>
    <v-row>
      <v-spacer></v-spacer>
      <v-col
          cols="12"
          xs="12"
          sm="12"
          md="12"
          lg="9"
          xl="6"
      >
        <v-card class="mb-4">
          <v-card-title>
            Entwickler
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                @click="fetchAll"
                :loading="loadingMyIp || loadingMyDevice"
            >
              <v-icon left>mdi-refresh</v-icon>
              Aktualisieren
            </v-btn>
          </v-card-title>
        </v-card>

        <endpoint-card
            title="Netzwerk"
            icon="mdi-ip-network"
            path="/api/myip"
            :response="responseMyIp"
            :error="errorMyIp"
            :loading="loadingMyIp"
            @refresh="fetchEndpoint('/api/myip')"
            class="mb-4"
        ></endpoint-card>

        <endpoint-card
            title="Gerät"
            icon="mdi-devices"
            path="/api/mydevice"
            :response="responseMyDevice"
            :error="errorMyDevice"
            :loading="loadingMyDevice"
            @refresh="fetchEndpoint('/api/mydevice')"
        ></endpoint-card>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
import EndpointCard from "../components/Dev/EndpointCard";

export default {
  name: "Dev",
  components: { EndpointCard },
  data: () => ({
    responseMyIp: null,
    responseMyDevice: null,
    errorMyIp: null,
    errorMyDevice: null,
    loadingMyIp: false,
    loadingMyDevice: false,
  }),
  methods: {
    setLoading(context, value) {
      if (context === "/api/myip") this.loadingMyIp = value
      if (context === "/api/mydevice") this.loadingMyDevice = value
    },
    setResponse(context, value) {
      if (context === "/api/myip") this.responseMyIp = value
      if (context === "/api/mydevice") this.responseMyDevice = value
    },
    setError(context, value) {
      if (context === "/api/myip") this.errorMyIp = value
      if (context === "/api/mydevice") this.errorMyDevice = value
    },
    fetchEndpoint(context) {
      this.setError(context, null)
      this.setLoading(context, true)
      fetch(context, { method: "GET" })
          .then((response) => {
            if (response.status === 200) {
              return response.text()
            } else {
              throw new Error("StatusCode " + response.status)
            }
          })
          .then((text) => {
            try {
              this.setResponse(context, JSON.parse(decodeURIComponent(text)))
            } catch (e) {
              this.setResponse(context, text)
            }
          })
          .catch((err) => {
            this.setError(context, err.message || String(err))
            this.setResponse(context, null)
          })
          .finally(() => {
            this.setLoading(context, false)
          })
    },
    fetchAll() {
      this.fetchEndpoint("/api/myip")
      this.fetchEndpoint("/api/mydevice")
    },
  },
  mounted() {
    this.fetchAll()
  },
}
</script>
